var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Select as $Select, Typography } from "antd";
import { Field } from "formik";
import React, { Component } from "react";
var Select = /** @class */ (function (_super) {
    __extends(Select, _super);
    function Select(props) {
        var _this = _super.call(this, props) || this;
        _this.focusHandler = function () {
            var firstActiveValue = _this.props.firstActiveValue;
            if (firstActiveValue) {
                setTimeout(function () {
                    var dropdown = document.getElementsByClassName(_this.dropdownClassname)[0];
                    if (dropdown) {
                        var ul = dropdown.getElementsByTagName('ul')[0];
                        if (ul) {
                            var items = ul.getElementsByTagName('li');
                            var firstItem = Array.from(items).find(function (i) { return i.innerText === firstActiveValue; });
                            if (firstItem) {
                                ul.scrollTop = firstItem.getBoundingClientRect().top - ul.getBoundingClientRect().top;
                            }
                        }
                    }
                });
            }
        };
        // This only one way to identify select (based on question.id), even if questions change select still stay unique 
        _this.dropdownClassname = "select-dropdown-" + props.question.id;
        return _this;
    }
    Select.prototype.render = function () {
        var _this = this;
        var _a = this.props, name = _a.name, validate = _a.validate, onChange = _a.onChange, onBlur = _a.onBlur, question = _a.question, firstActiveValue = _a.firstActiveValue, children = _a.children, restProps = __rest(_a, ["name", "validate", "onChange", "onBlur", "question", "firstActiveValue", "children"]);
        return (React.createElement(Field, { name: name, validate: validate }, function (_a) {
            var value = _a.field.value, _b = _a.form, setFieldValue = _b.setFieldValue, setFieldTouched = _b.setFieldTouched;
            return (React.createElement(React.Fragment, null,
                React.createElement(Typography, null, question.text),
                React.createElement($Select, __assign({ onChange: function (value, option) {
                        setFieldValue(name, value);
                        onChange && onChange(value, option);
                    }, onBlur: function (value) {
                        setFieldTouched(name);
                        onBlur && onBlur(value);
                    }, onDropdownVisibleChange: function (isOpen) {
                        if (isOpen) {
                            _this.focusHandler();
                        }
                    }, value: value }, restProps, { dropdownClassName: _this.dropdownClassname + " " + _this.props.dropdownClassName }), children)));
        }));
    };
    Select.renderOptions = function (options) {
        return options.map(function (_a, index) {
            var label = _a.label, restProps = __rest(_a, ["label"]);
            return (React.createElement($Select.Option, __assign({ key: "select-option-" + index }, restProps), label));
        });
    };
    Select.Option = $Select.Option;
    Select.OptGroup = $Select.OptGroup;
    return Select;
}(Component));
export { Select };
;
export default Select;
// Select.renderOptions = (options: Option[]) =>
//     options.map(({ label, ...restProps }, index) => (
//         <$Select.Option key={`select-option-${index}`} {...restProps}>
//             {label}
//         </$Select.Option>
//     ));
// Select.Option = $Select.Option;
// Select.OptGroup = $Select.OptGroup;
/*
 * export const Select = ({ name, validate, onChange, onBlur, question, ...restProps }: SelectProps) => {
    return (
        <Field name={name} validate={validate}>
            {({ field: { value }, form: { setFieldValue, setFieldTouched } }: FieldProps) => (
                <>
                    <Typography>{question.text}</Typography>
                    <$Select
                        onChange={(value, option) => {
                            setFieldValue(name, value)
                            onChange && onChange(value, option)
                        }}
                        onBlur={value => {
                            setFieldTouched(name)
                            onBlur && onBlur(value)
                        }}
                        value={value}
                        {...restProps}

                    >
                        {question.options.map(opt => <Select.Option key={opt.id} value={`${opt.id}`}>{opt.text}</Select.Option>)}
                    </$Select>
                </>
            )}
        </Field>
    );
};
 */ 



//////////////////
// WEBPACK FOOTER
// ./src/components/forms/Select/Select.tsx
// module id = 1479
// module chunks = 0